export default __webpack_public_path__ + "static/media/office1-before2-1024w.f2974b4d.png";